<template>
  <div>
    <div>
      <div class="media">
        <div class="media-content">
          <p class="has-text-link has-text-weight-bold p_size14">
            {{dataInfoCommercial.contact.nom}}
            {{dataInfoCommercial.contact.prenom}}
          </p>
          <p class="p_size12 has-text-default">
            Commercial(e) chez
            <strong class="has-text-default">
              {{dataInfoCommercial.nomCommercial}}
            </strong>
          </p>
        </div>
      </div>
    </div>
    <div class="has-background-info has-text-white
    topViolet bottomVert commercialContent p_size14">
      <p>Une question ?</p>
      <div v-if="telCommercial">
        <p> Contactez-moi au
          <span class="has-text-weight-bold underline">{{telCommercial}}</span> <br>
          ou par email
          <a
            :href="`mailto:${dataInfoCommercial.contact.email}`"
            class="has-text-weight-bold has-text-white underline">
            {{dataInfoCommercial.contact.email}}
          </a>
        </p>
      </div>
      <div v-else>
        <p>Contactez moi par mail
          <a :href="`mailto:${dataInfoCommercial.contact.email}`"
             class="has-text-weight-bold has-text-white underline">
            {{dataInfoCommercial.contact.email}}
          </a>
        </p>
      </div>
    </div>
    <telecharger></telecharger>
  </div>
</template>

<script>
import telecharger from './telecharger';

export default {
  name: 'infoCommercial',
  props: ['dataInfoCommercial'],
  components: { telecharger },
  computed: {
    telCommercial() {
      return this.dataInfoCommercial.contact.telephone;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/composants/infoCommercial.vue